import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CreateClientDto,
  CreateFaqResponse,
} from '@ansvar-sakerhet/api-client';
import { useApi } from '../useApi';
import { clientKeys } from './clients.key';
import { toast } from '../../../components/Toast';

type Options = {
  onCreateQuestionSuccess?: (data: CreateFaqResponse) => void;
  onCreateQuestionError?: (error: unknown) => void;
};

export function useCreateClient(options?: Options) {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const createClient = async (data: CreateClientDto) => {
    const api = await getApi();

    const res = await api.clientsCreate(data);

    return res.data;
  };

  const onSuccess = () => {
    toast.success('CLient har lagts till');
    queryClient.invalidateQueries({ queryKey: clientKeys.all });
  };

  const onError = (error: unknown) => {
    toast.error('Något gick fel');

    options?.onCreateQuestionError?.(error);
  };

  const mutation = useMutation(createClient, {
    onSuccess,
    onError,
  });

  return mutation;
}
